import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';

@Injectable()
export class RequestsMetricsService {
  private readonly baseUrl = environment.api_base_url;
  private readonly apiUrl = `${this.baseUrl}request-metrics`;

  constructor(private readonly http: HttpClient) {}

  getStatistics<T = any>(params?: any): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}/statistics`, {
      params: this.createParams(params),
    });
  }

  getActivity<T = any>(
    pagination?: any,
  ): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}/activity`, {
      params: this.createParams(pagination),
    });
  }

  getUserActivity<T = any>(
    userId: string | number,
    pagination?: any,
  ): Observable<T> {
    return this.http.get<T>(
      `${this.apiUrl}/users/${encodeURIComponent(String(userId))}/activity`,
      { params: this.createParams(pagination) },
    );
  }

  getEndpointActivity<T = any>(
    endpoint: string,
    pagination?: any,
  ): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}/endpoint-activity`, {
      params: this.createParams({
        ...pagination,
        endpoint,
      }),
    });
  }

  getTopEndpoints<T = any>(
    pagination?: any,
  ): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}/top-endpoints`, {
      params: this.createParams(pagination),
    });
  }

  getEndpoints<T = any>(
    options?: any,
  ): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}/endpoints`, {
      params: this.createParams(options),
    });
  }

  getSlowestEndpoints<T = any>(
    pagination?: any,
  ): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}/slowest-endpoints`, {
      params: this.createParams(pagination),
    });
  }

  getDbHeavyEndpoints<T = any>(
    pagination?: any,
  ): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}/db-heavy-endpoints`, {
      params: this.createParams(pagination),
    });
  }

  getTopUsers<T = any>(
    pagination?: any,
  ): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}/top-users`, {
      params: this.createParams(pagination),
    });
  }

  getRecentSlowRequests<T = any>(
    pagination?: any,
  ): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}/recent-slow`, {
      params: this.createParams(pagination),
    });
  }

  getRecentErrors<T = any>(
    pagination?: any,
  ): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}/recent-errors`, {
      params: this.createParams(pagination),
    });
  }

  getStatusCodes<T = any>(
    pagination?: any,
  ): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}/status-codes`, {
      params: this.createParams(pagination),
    });
  }

  getMethods<T = any>(
    pagination?: any,
  ): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}/methods`, {
      params: this.createParams(pagination),
    });
  }

  getTimeline<T = any>(
    bucket: 'hour' | 'day',
    pagination?: any,
  ): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}/timeline`, {
      params: this.createParams({
        ...pagination,
        bucket,
      }),
    });
  }

  getFilters<T = any>(): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}/filters`);
  }

  private createParams(
    values?: Record<string, string | number | boolean | null | undefined>,
  ): HttpParams {
    let params = new HttpParams();

    const paramsSource = values || {};
    Object.keys(paramsSource).forEach((key) => {
      const value = paramsSource[key];
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, String(value));
      }
    });

    return params;
  }

  infinte(url) {
    return this.http.get<any>(
      `${url}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/monitoring/service/requests-metrics.service.ts